import { render, staticRenderFns } from "./addServisMarkupModal.vue?vue&type=template&id=6f5c8f54&scoped=true&"
import script from "./addServisMarkupModal.vue?vue&type=script&lang=ts&"
export * from "./addServisMarkupModal.vue?vue&type=script&lang=ts&"
import style0 from "./addServisMarkupModal.vue?vue&type=style&index=0&id=6f5c8f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c8f54",
  null
  
)

export default component.exports